import type { ServiceRow, ServiceTypeFilter } from './api';

const LAMBDA_SERVICE_TYPES = new Set(['lambda', 'monolambda']);

/** Missing types are excluded from typed pickers during mixed-version deployments. */
export function filterServicesByType(
  services: ServiceRow[],
  filter?: ServiceTypeFilter,
): ServiceRow[] {
  if (!filter) return services;
  return services.filter(service => {
    const type = service.type?.trim().toLowerCase();
    if (!type) return false;
    return filter === 'lambda'
      ? LAMBDA_SERVICE_TYPES.has(type)
      : !LAMBDA_SERVICE_TYPES.has(type);
  });
}
